<template>
  <transition name="fade">
    <div class="modal-wrapper" v-if="show" @click.stop>
      <div
        id="dialog"
        class="modal-dialog"
        :style="styleObject"
        ref="modal">
        <div class="modal-header">
          <img src="../assets/images/icons/icon-close-20.png"
            class="modal-close"
            @click='closeFn()'/>
            <slot name="header"></slot>
        </div>
        <div
          class="modal-body"
          :style="styleBody">
          <slot></slot>
        </div>
        <div class="modal-footer" v-if="showCancel">
          <slot name="footer">
            <button class="btn btn-ok" :disabled="disabled" :class="[okColor]" :style="cancelt?'':'width:160px'"
              @click='okFn()'>{{okt}}</button>
            <button class="btn btn-cancel"
              @click='cancelFn()' v-if="cancelt">{{cancelt}}</button>
          </slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    props: {
      title: String,
      disabled: {
        type: Boolean,
        default: false
      },
      show: {
        type: Boolean,
        default: false
      },
      okt: {
        type: String,
        default: '确定'
      },
      showCancel: {
        type: Boolean,
        default: true
      },
      cancelt: {
        type: String,
        default: '取消'
      },
      mwidth: {
        type: String,
        default: '600'
      },
      // modal-body padding  带px 的字符串
      bodyPadding: String,
      // 确定按钮 背景颜色，可自行在 本vue 文件下方自行添加
      okColor: {
        type: String,
        default: 'orgrent'
      }
    },
    computed: {
      styleObject () {
        return {
          width: this.mwidth + 'px'
        }
      },
      styleBody () {
        return {
          padding: this.bodyPadding
        }
      }
    },
    methods: {
      cancelFn () {
        this.$emit('cancel')
      },
      hide () {
        this.$emit('close')
      },
      okFn () {
        this.$emit('ok')
      },
      closeFn () {
        this.$emit('close')
      }
    },
    watch: {
      mwidth: {
        handler (val) {
          this.styleObject.width = this.mwidth + 'px'
        },
        immediate: true
      }
    }
  }
</script>

<style lang="postcss">
   .header-body {
      font-size: 20px;
      color: #333;
      letter-spacing: 2px;
      font-weight: bold;
      text-align: center;
      margin-top: 50px;
    }
</style>

<style lang="less" scoped>
.modal-wrapper {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  overflow: auto;
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 8;
  cursor: default;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: normal;

  .modal-dialog {
    width: 600px;
    background: #fff;
    border-radius: 6px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    box-sizing: border-box;
    padding-top: 1px;
    // max-height: 95vh;
    overflow-y: auto;

    .modal-header {
      position: relative;
      padding-top: 0;
      font-weight: normal;

      .modal-close {
        display: inline-block;
        position: absolute;
        right: 20px;
        top: -30px;
        width: 20px;
        height: 20px;
        cursor: pointer;
      }

      .header-body {
    		font-size: 20px;
    		color: #333;
    		letter-spacing: 2px;
        font-weight: bold;
    		text-align: center;
    		margin-top: 50px;
    	}
    }

    .modal-body {
      padding: 30px 30px;
      font-size: 16px;
      text-align: center;
      color: #666;
      letter-spacing: 1.31px;
      line-height: 19px;
    }

    .modal-content {
      text-align: left;

      .txt-area {
        display: inline-block;
        margin-left: 42px;
        padding: 8px;
        width: 90%;
        height: 60px;
        margin-top: 10px;
        border-radius: 4px;
        border: solid 1px #e0e0e0;
        resize: none;
        font-size: 13px;
        color: #999;
      }

      .err-info {
        line-height: 30px;
        margin-left: 0;
      }

      .err {
        margin-top: 5px;
        margin-left: 42px;
        color: #ff6204;
        padding-left: 20px;
        background-size: 16px;
        line-height: 25px;
      }
    }
    .opt-tips {
      line-height: 14px;
      font-size: 14px;
      letter-spacing: 1.1px;
      color: #cacaca;
      text-align: center;
      padding-top: 30px;
    }
    .input-box {
      margin-top: 20px;
      font-size: 14px;
      letter-spacing: 1.1px;
      color: #666;
      line-height: 45px;
      height: 45px;
      &:first-child {
        margin-top: 0;
      }
      dt {
        width: 122px;
        font-weight: normal;
        display: inline-block;
        float: left;
      }
      dd {
        display: inline-block;
        overflow: hidden;
        height: 45px;
        border: solid 1px #ebebeb;
        box-sizing: border-box;
        border-radius: 4px;
        position: relative;
      }
      input:disabled {
        background-color: #f7f7f7;
        height: 43px;
        display: block;
      }
      .input-form {
        margin: 0;
      }
    }
    .question {
      li {
        list-style: none;
        margin-top: 20px;

        .cbx {
          display: none;
        }

        label {
          padding-left: 46px;
          display: inline-block;
          height: 18px;
          line-height: 18px;
        }

        .cbx + label {
          background: url(../assets/images/icons/icon_checkbox_unselect.png) no-repeat left top;
        }

        .cbx:checked + label {
          background: url(../assets/images/icons/icon_checkbox_select.png) no-repeat left top;
        }
      }
    }

    .modal-footer {
      padding: 0 30px 50px;
      text-align: center;
      box-sizing: border-box;

      button {
        width: 120px;
        border: 0;
        height: 34px;
        border-radius: 4px;
        font-size: 14px;
        padding: 0;
        text-align: center;
        cursor: pointer;
        letter-spacing: 1px;
      }

      .confirm-btn {
        width: 160px;
        background-color: #F46A00;
        color: #fff;
        margin: 20px auto 30px;
        &:disabled {
          background: #ccc;
          cursor: default;
        }
      }
      button:disabled {
        background: #eaeaea;
        cursor: default;
        border: 1px solid #eaeaea;
        color: #999;
      }
      .btn-ok {
        display: inline-block;
        margin: 0;
      }

      .red {
        background-color: #f66;
      }

      .blue {
        border: 1px solid #F46A00;
        background-color: #F46A00;
        color: #fff;
        & + button:hover {
          border: 1px solid #F46A00;
          color: #F46A00;
        }
      }

      .green {
        border: 1px solid #28cc75;
        background-color: #28cc75;
        color: #fff;
        & + button:hover {
          border: 1px solid #28cc75;
          color: #28cc75;
        }
      }
      .orgrent {
        border: 1px solid #F46A00;
        background-color: #F46A00;
        color: #fff;
        & + button:hover {
          border: 1px solid #F46A00;
          color: #F46A00;
        }
      }

      .new-pro {
        margin-left: -65px;
        border: 1px solid #F46A00;
        background-color: #F46A00;
        color: #fff;
      }

      .btn-cancel {
        display: inline-block;
        background: #fff;
        border: 1px solid #ebebeb;
        color: #999;
        margin-left: 20px;

        &:hover {
          color: #F46A00;
          border: 1px solid #F46A00;
        }
      }
    }
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-active {
  opacity: 0;
}
</style>
